import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import { toast } from "react-toastify";
import swal from "sweetalert";
import "react-toastify/dist/ReactToastify.css";

export const Add_ProPerty = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newAvailableProperty/${id}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.ADD_PROPERTY,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Property Created Error");
    }
  };
};

export const Get_List_Rent_Property = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailablePropertyRent`,
        config
      );
      dispatch({
        type: actions.GET_LIST_PROPERTY_RENT,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const Get_List_Sell_Property = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailablePropertysSell`,
        config
      );
      dispatch({
        type: actions.GET_LIST_PROPERTY_SELL,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const View_Detail_Each_Sell = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_SELL,
        payload: res.data.data,
        sell_pr_agent: res.data.data.agentId,
      });
    } catch (error) { }
  };
};

export const View_Detail_Each_Rent = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_RENT,
        payload: res.data.data,
        rent_pr_agent: res.data.data.agentId,
      });
    } catch (error) { }
  };
};

export const Property_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateAvailablePropertyStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_PROPERTY_STATUS });
      swal({
        title: "Good job!",
        text: "Update  Status  Successfuly !",
        icon: "success",
        timer: 1000,
      });
    } catch (error) { }
  };
};

export const View_Update_Each_Sell = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_UPDATE_PROPERTY_SELL,
        payload: res.data.data,
      });
      dispatch(Get_List_Sell_Property());
    } catch (error) { }
  };
};

export const View_Update_Each_Rent = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_UPDATE_PROPERTY_RENT,
        payload: res.data.data,
      });
      dispatch(Get_List_Rent_Property());
    } catch (error) { }
  };
};

export const Add_Required_ProPerty = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newRequiredProperty/${id}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.ADD_REQUIRED_PROPERTY,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Property Required Created Error");
    }
  };
};

export const Get_List_Required_Property = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getRequiredPropertysSell`,
        config
      );
      dispatch({
        type: actions.GET_LIST_PROPERTY_REQUIRED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const Get_List_Required_Property_Rent = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRequiredPropertyRent`, config);
      dispatch({
        type: actions.GET_LIST_PROPERTY_REQUIRED_RENT,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const View_Detail_Required_Property = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getRequiredProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_REQUIRED_PROPERTY,
        payload: res.data.data,
      });
      return res.data.data;
    } catch (error) { }
  };
};

export const View_Detail_Required_Property_Rent = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getRequiredProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_REQUIRED_PROPERTY_RENT,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const Update_Sell_Property = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/updateAvailableProperty/${id}`,
        { ...data },
        config
      );
      if (res.status === 200) {
        dispatch({
          type: actions.UPDATE_SELL,
          payload: res.data.data,
        });
      }
    } catch (error) {
      toast.error("Update Sell Property Faieled");
    }
  };
};

export const Update_Rent_Property = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/updateAvailableProperty/${id}`,
        { ...data },
        config
      );
      if (res.status === 200) {
        dispatch({
          type: actions.UPDATE_RENT,
          payload: res.data.data,
        });
      }
    } catch (error) {
      toast.error("Update Rent Property Faieled");
    }
  };
};

export const Property_Rent_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateAvailablePropertyStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_PROPERTY_RENT_STATUS });
    } catch (error) { }
  };
};

export const Property_Sell_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateAvailablePropertyStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_PROPERTY_SELL_STATUS });
    } catch (error) { }
  };
};

export const Required_Rent_Status = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateRequiredPropertyStatus/${id}?status=${"delete"}`,
        config
      );
      dispatch({ type: actions.UPDATEING_REQUIRED_RENT_STATUS, id: id });
    } catch (error) { }
  };
};

export const Required_Sell_Status = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateRequiredPropertyStatus/${id}?status=${"delete"}`,
        config
      );
      dispatch({ type: actions.UPDATEING_REQUIRED_SELL_STATUS, id: id });
    } catch (error) { }
  };
};

export const Property_Required_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateRequiredPropertyStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_PROPERTY_REQUIRED_STATUS });
    } catch (error) { }
  };
};

export const Delete_Avilable_Property = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/delteAvailable/${id}`, config);
      dispatch({ type: actions.DELETE_AVILABLEPROPERTY, id: id });
    } catch (error) { }
  };
};

export const Delete_Avilable_Property_Rent = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/delteAvailable/${id}`, config);
      dispatch({ type: actions.DELETE_AVILABLEPROPERTY_RENT, id: id });
    } catch (error) { }
  };
};

export const Update_Required = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/updateRequiredProperty/${id}`,
        { ...data },
        config
      );
      if (res.status === 200) {
        dispatch({
          type: actions.UPDATE_REQUIRED_PROPERTY,
          payload: res.data.data,
        });
      }
    } catch (error) { }
  };
};

// customer Detail
export const Add_Customer_Detail = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(`/api/v1/Custmer`, { ...data }, config);
      dispatch({
        type: actions.CREATE_DETAIL_OF_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const Get_List_Customers = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CustmerAgent`, config);
      dispatch({
        type: actions.GET_DETAIL_OF_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const View_Customer = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Custmer/${id}`, config);
      dispatch({
        type: actions.CUSTOMER_VIEWED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const Update_Customer = (id, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/Custmer/${id}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CISTOMER_UPDATED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

export const Customer_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/Custmer/${id}`, config);
      dispatch({ type: actions.CUSTOMER_DELETED, id: id });
    } catch (error) { }
  };
};
// customer Call
export const Add_Customer_Call = (custmerId, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/Call/${custmerId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_CALL_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const Get_List_CustomersCall = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CallAgent`, config);
      dispatch({
        type: actions.GET_CALL_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const View_CustomerCall = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Call/${id}`, config);
      dispatch({
        type: actions.CUSTOMERCALL_VIEWED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const Update_CustomerCall = (id, customerId, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/Call/${id}?id=${customerId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CISTOMERCALL_UPDATED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const CustomerCall_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/Call/${id}`, config);
      dispatch({ type: actions.CUSTOMERCALL_DELETED, id: id });
    } catch (error) { }
  };
};
// customer service
export const Add_Customer_Service = (custmerId, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/CustmerService/${custmerId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_SERVICE_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const Get_List_CustomersService = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CustmerServiceAgent`, config);
      dispatch({
        type: actions.GET_SERVICE_CUSTOMER,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const View_CustomerService = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CustmerService/${id}`, config);
      dispatch({
        type: actions.CUSTOMERSERVICE_VIEWED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const Update_CustomerService = (id, customerId, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/CustmerService/${id}?id=${customerId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CISTOMERSERVICE_UPDATED,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};
export const CustomerService_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/CustmerService/${id}`, config);
      dispatch({ type: actions.CUSTOMERSERVICE_DELETED, id: id });
    } catch (error) { }
  };
};

export const Get_List_Zabuns = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ListZabwnAgent`, config);
      dispatch({
        type: actions.GET_DETAIL_OF_ZABUN,
        payload: res.data.data,
      });
    } catch (error) { }
  };
};

